{
  "version": 1,
  "asset_id": "30612107-b8a8-4a9c-a2e6-a6df9916b1f1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/30612107-b8a8-4a9c-a2e6-a6df9916b1f1/bypass-normal-boxed-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/30612107-b8a8-4a9c-a2e6-a6df9916b1f1/bypass-normal-boxed-es-480.webp",
  "original_filename": "bypass-normal-boxed-es-480.webp",
  "size": 12790,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:11:30Z"
}
